import { Form, Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { InfoCard2 } from '../../widgets/components/UI/InfoCard2'
import TextArea from '../../widgets/components/Input/TextArea'
import { Formik } from 'formik'
import { useState } from 'react'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import { aiGenerateBr, aiGenerateMoM } from '../core/_requests'
import { useAuth } from '../../auth'
import { Quill } from '../../widgets/components/Input/Quill'

export default function AIGeneratedBrModal({
  isActiveModal,
  setIsActiveModal,
  isTab,
  setAiGeneratedData,
  transcriptData
}: any) {
  const { formatMessage } = useIntl()
  const { companyId } = useAuth()
  const [loading, setLoading] = useState(false)
  const [quillText, setQuillText] = useState('')

  const options = [
    {
      id: 1,
      title: formatMessage({ id: 'Option 1' }),
      subTitle: formatMessage({ id: 'Schedule Online Meeting' }),
      slug: 'Recording',
    },
    {
      id: 2,
      title: formatMessage({ id: 'Option 2' }),
      subTitle: formatMessage({ id: 'Schedule Online Meeting' }),
      slug: 'Board-Resolution',
    },
    {
      id: 3,
      title: formatMessage({ id: 'Option 3' }),
      subTitle: formatMessage({ id: 'Schedule Online Meeting' }),
      slug: 'Minutes-Of-Meeting',
    },
    {
      id: 4,
      title: formatMessage({ id: 'Option 4' }),
      subTitle: formatMessage({ id: 'Schedule Online Meeting' }),
      slug: 'Transcript',
    },
  ]
  const [tab, setTab] = useState(1)
  const [data, setData] = useState<any>([])
  const handleTabChange = (index: number) => {
    setTab(index + 1)
  }
  const userSchema = Yup.object().shape({
    BRResolution: Yup.string(),
    MinutesOfMeeting: Yup.string(),
    MeetingTranscript: Yup.string(),
  })
  const initialValues = {
    MinutesOfMeeting: '',
    BRResolution: '',
    MeetingTranscript: '',
    AIGeneratedBR: isTab === 2 ? data.length > 0 && data?.[tab - 1] : isTab === 3 ? data : '',
  }
  const handleSubmit = async (values: any) => {
    if (isTab === 2) {
      if (!values.BRResolution) return toast.error(formatMessage({ id: 'A board resolution is required.' }))
      if (!values.MinutesOfMeeting) return toast.error(formatMessage({ id: 'Minutes of Meeting is required.' }))
      if (!values.MeetingTranscript) return toast.error(formatMessage({ id: 'A meeting transcript is required.' }))
      const payload = {
        meetingTranscript: values.MeetingTranscript,
        minutesOfMeeting: values.MinutesOfMeeting,
        boardResolutionTopics: values.BRResolution,
      }
      try {
        setLoading(true)
        const {
          data: { success, data },
        } = await aiGenerateBr(payload, companyId)
        if (success) {
          setData(data.boardResolutions)
        }
      } catch (e) {
        console.log(e)
      } finally {
        setLoading(false)
      }
    }
    if (isTab === 3) {
      if (!values.MeetingTranscript) return toast.error(formatMessage({ id: 'A meeting transcript is required.' }))
      try {
        setLoading(true)
        const payload = {
          meetingTranscript: values.MeetingTranscript,
        }
        const {
          data: { success, data },
        } = await aiGenerateMoM(payload, companyId)
        if (success) {
          setData(data.minutesOfMeeting)
        }
      } catch (e) {
        console.log(e)
      } finally {
        setLoading(false)
      }
    }
  }

  console.log(quillText, ' quillText')
  return (
    <>
      <Modal
        show={isActiveModal}
        onHide={() => {
          setIsActiveModal(false)
        }}
        fullscreen
      >
        <Modal.Header closeButton>
          <div className='d-flex flex-column'>
            <h2>{isTab === 2 ? formatMessage({ id: 'AI-generated BR' }) : formatMessage({ id: 'Generate MoM using the Transcript of this meeting' })}</h2>
          </div>
        </Modal.Header>

        <Formik
          initialValues={initialValues}
          validationSchema={userSchema}
          onSubmit={() => { }}
          validateOnMount
          enableReinitialize
        >
          {(formik) => {
            console.log(formik)
            return (
              <>
                <Modal.Body>
                  <Form>
                    <InfoCard2
                      title={isTab === 2 ? formatMessage({ id: 'AI-Powered Board Resolution' }) : formatMessage({ id: 'AI-Generated Minutes-of-Meeting' })}
                      desc={isTab === 2 ? formatMessage({ id: 'Craft impactful and efficient BR with the help of AI, directly from your dashboard. Enhance your compliance work with well-structured, professional BR tailored to your needs.' }) : formatMessage({ id: 'Generate to the point and efficient MoM with the help of AI, directly from your dashboard. Enhance your compliance work with well-structured, professional MoM tailored to your needs.' })}
                      slug='#'
                      className='w-100'
                    />

                    <div className='row'>
                      <div className='col-12'>
                        {isTab === 2 && (
                          <TextArea
                            label={formatMessage({
                              id: 'Enter the BR Topics or Resolutions you are looking to pass',
                            })}
                            fieldName='BRResolution'
                            formik={formik}
                            placeholder={formatMessage({
                              id: 'Enter the details or key points included in this Board Resolution.',
                            })}
                            toolTipText={formatMessage({
                              id: 'Enter the details or key points included in this Board Resolution.',
                            })}
                            isStarRequired={true}
                            isTooltipForModal={true}
                          />
                        )}
                        {isTab === 2 && (
                          <TextArea
                            label={formatMessage({
                              id: 'Enter the meeting topics from the MoM of this Board Meeting',
                            })}
                            fieldName='MinutesOfMeeting'
                            formik={formik}
                            placeholder={formatMessage({
                              id: 'Enter the details or key points included in this Minutes Of Meeting',
                            })}
                            toolTipText={formatMessage({
                              id: 'Enter the details or key points included in this Minutes Of Meeting',
                            })}
                            isStarRequired={true}
                            isTooltipForModal={true}
                          />
                        )}
                        {(isTab === 2 || isTab === 3) && (
                          <TextArea
                            label={isTab === 2 ? formatMessage({
                              id: 'Enter the full meeting transcript of this Board Meeting',
                            }) : formatMessage({ id: 'Enter the transcript of this meeting to generate the Minutes Of Meeting' })}
                            fieldName='MeetingTranscript'
                            formik={formik}
                            placeholder={formatMessage({
                              id: 'Enter the details or key points included in this Transcript.',
                            })}
                            toolTipText={formatMessage({
                              id: 'Enter the details or key points included in this Transcript.',
                            })}
                            isStarRequired={true}
                            isTooltipForModal={true}
                          />
                        )}
                        <button
                          className='btn btn-primary w-md-auto w-100'
                          type='button'
                          onClick={() => handleSubmit(formik.values)}
                          disabled={loading}
                        >
                          {loading
                            ? formatMessage({ id: 'Please Wait...' })
                            : isTab === 2
                              ? formatMessage({ id: 'Generate BR' })
                              : formatMessage({ id: 'Generate MoM' })}
                        </button>
                      </div>
                      {isTab === 2 && (
                        <div
                          className='p-0 mt-8 px-3'
                          style={{
                            overflowX: 'scroll',
                            whiteSpace: 'nowrap',
                            scrollbarWidth: 'none',
                            msOverflowStyle: 'none',
                          }}
                        >
                          <div
                            className='d-flex gap-3 col-md-8 col-12 mt-8 mt-md-0'
                            style={{
                              display: 'flex',
                              flexWrap: 'nowrap',
                              scrollbarWidth: 'none',
                              msOverflowStyle: 'none',
                            }}
                          >
                            {/* Rectangular tabs Start */}
                            {options.map((opt, index) => (
                              <div
                                key={index}
                                className={
                                  `col options-container p-4 align-content-center cursor-pointer ` +
                                  (tab === index + 1 ? ' selected-option' : '')
                                }
                                style={{ width: '200px', flex: '0 0 auto' }}
                                onClick={() => handleTabChange(index)}
                              >
                                <h1 className='m-0'>{formatMessage({ id: opt.title })}</h1>
                                <p
                                  className='mt-2'
                                  style={{ whiteSpace: 'normal', color: '#656571' }}
                                >
                                  {formatMessage({ id: opt.subTitle })}
                                </p>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      <div className='col-12 mt-5'>
                        <Quill
                          quillText={quillText}
                          setQuillText={setQuillText}
                          aiEmailResponse={formik.values.AIGeneratedBR}
                          isDisabled={!loading}
                        />
                      </div>
                    </div>
                  </Form>
                </Modal.Body>
                <Modal.Footer className='p-md-0 px-0 container d-flex'>
                  <div className='d-flex my-md-4 mx-6 mx-md-0 my-0 mb-2 justify-content-md-end justify-content-center w-md-auto w-100 order-2 order-md-1 mb-2'>
                    <button
                      className='btn bg-light custom-button-property text-muted font-size-13 me-md-2 me-0 fw-normal w-100 w-md-auto'
                      style={{ padding: '15px 40px' }}
                      type='button'
                      onClick={() => {
                        setIsActiveModal(false)
                      }}
                    >
                      <span className='indicator-label font-size-13 p-0'>
                        {formatMessage({ id: 'Cancel' })}
                      </span>
                    </button>
                  </div>
                  <div className='d-flex my-md-4 mx-6 mx-md-0 my-0 justify-content-md-end justify-content-center w-md-auto w-100 order-1 order-md-2 mb-2'>
                    <button
                      className='btn bg-primary custom-button-property text-white font-size-13 me-md-2 me-0 fw-normal w-100 w-md-auto'
                      style={{ padding: '15px 40px' }}
                      type='button'
                      onClick={() => {
                        setAiGeneratedData(formik.values.AIGeneratedBR)
                        setIsActiveModal(false)
                      }}
                    >
                      <span className='indicator-label font-size-13 p-0'>
                        {formatMessage({ id: 'Insert' })}
                      </span>
                    </button>
                  </div>
                </Modal.Footer>
              </>
            )
          }}
        </Formik>
      </Modal>
    </>
  )
}